import React from 'react';

/**
 * Componente para exibir um cartão com informações de propriedade
 * com título, subtítulo, cor personalizada e rodapé opcional
 */
const PropertyCard = ({ title, subtitle, color = 'blue', footer = null, children }) => {
  const colorVariants = {
    blue: 'border-blue-500 bg-blue-50',
    green: 'border-green-500 bg-green-50',
    amber: 'border-amber-500 bg-amber-50',
    red: 'border-red-500 bg-red-50',
    gray: 'border-gray-500 bg-gray-50',
    purple: 'border-purple-500 bg-purple-50',
  };

  const borderColor = colorVariants[color]?.split(' ')[0] || 'border-gray-300';
  const _bgColor = colorVariants[color]?.split(' ')[1] || 'bg-white';

  return (
    <div
      className={`rounded-lg overflow-hidden border-l-4 ${borderColor} bg-white shadow-sm hover:shadow transition-all duration-200`}
    >
      {/* Header */}
      <div className="p-2 pb-1.5 border-b border-gray-100 flex flex-col">
        {subtitle && (
          <p className="MuiTypography-root MuiTypography-body2 text-xs text-gray-500 mb-0.5">
            {subtitle}
          </p>
        )}
        <h3 className="text-base font-medium text-gray-800">{title}</h3>
      </div>

      {/* Content */}
      <div className="p-2 text-sm">{children}</div>

      {/* Footer (opcional) */}
      {footer && <div className="px-2 py-1.5 bg-gray-50 border-t border-gray-100">{footer}</div>}
    </div>
  );
};

export default PropertyCard;
